import properties from 'resources/constants/properties.json';

import LocalStorageUtils from './LocalStorageUtils';

export default (() => {
  const getPropertyByApi = key => {
    const currentApi = LocalStorageUtils.getApiUrl();

    if(currentApi === properties.baseUrl.api) {
      return properties[key]
    }

    const extendedParams = Object.values(properties.extendedParams || {})
    const apiSpecificParams = extendedParams?.find(param => param?.api === currentApi)

    if(apiSpecificParams?.[key]) {
      return apiSpecificParams?.[key];
    } else {
      return properties[key];
    }
  }

  const getBaseApiObjByAPi = () => {
    const currentApi = LocalStorageUtils.getApiUrl();
    const dashboardUrl = getPropertyByApi('dashboardUrl')

    if(currentApi !== properties.baseUrl.api && dashboardUrl) {
      return {
        api: currentApi,
        dashboardUrl
      }
    }

    return properties.baseUrl
  }

  return {
    getPropertyByApi,
    getBaseApiObjByAPi
  }
})()
